import { useSyncExternalStore } from "react";

/** 로그인한 기기. 이 브라우저는 여기서 로그아웃하지 않는다. */
export type DeviceKind = "web" | "desktop";

export type SignedDevice = {
  id: string;
  name: string;
  kind: DeviceKind;
  lastUsedAt: string;
  current: boolean;
  signedOut: boolean;
};

const SEED: SignedDevice[] = [
  { id: "browser", name: "Chrome", kind: "web", lastUsedAt: "2026-10-01T13:00:00", current: true, signedOut: false },
  { id: "mac", name: "MacBook Pro", kind: "desktop", lastUsedAt: "2026-09-28T09:12:00", current: false, signedOut: false },
  { id: "win", name: "Windows", kind: "web", lastUsedAt: "2026-09-20T14:40:00", current: false, signedOut: false },
];

let devices: SignedDevice[] = SEED.map((row) => ({ ...row }));
let version = 0;
const listeners = new Set<() => void>();

function emit() {
  version += 1;
  for (const listener of listeners) listener();
}

export function resetDevices(): void {
  devices = SEED.map((row) => ({ ...row }));
  emit();
}

/** 목업. 기기 목록이 다이얼로그보다 길어지는 경우를 만든다. */
export function fillDevices(extra: number): void {
  const rows: SignedDevice[] = SEED.map((row) => ({ ...row }));
  for (let index = 0; index < extra; index += 1) {
    rows.push({
      id: `extra-${index}`,
      name: index % 2 === 0 ? `iPhone ${index + 1}` : `Windows ${index + 1}`,
      kind: index % 2 === 0 ? "desktop" : "web",
      lastUsedAt: "2026-09-01T09:00:00",
      current: false,
      signedOut: false,
    });
  }
  devices = rows;
  emit();
}

export function getDevices(): SignedDevice[] {
  return devices;
}

export function subscribeDevices(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDevices(): number {
  return useSyncExternalStore(subscribeDevices, () => version, () => version);
}

export function deviceKindLabel(kind: DeviceKind): string {
  return kind === "desktop" ? "데스크톱" : "웹";
}

/** 다른 기기만 로그아웃으로 표시한다. 이 기기와 없는 기기는 바꾸지 않는다. */
export function signOutDevice(id: string): boolean {
  const row = devices.find((device) => device.id === id);
  if (!row || row.current || row.signedOut) return false;
  devices = devices.map((device) => (device.id === id ? { ...device, signedOut: true } : device));
  emit();
  return true;
}

export function signOutOtherDevices(): number {
  const ids = devices.filter((device) => !device.current && !device.signedOut).map((device) => device.id);
  if (ids.length === 0) return 0;
  const drop = new Set(ids);
  devices = devices.map((device) => (drop.has(device.id) ? { ...device, signedOut: true } : device));
  emit();
  return ids.length;
}
